import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { HOST } from '../../global';
import { ESTADO_INFORMACION_PERIODO_ACTIVO_CHV } from '../../global';
import { CONSULTAR_BASE_HISTORICA_PERIODO_CHV } from '../../global';
import { CONSULTAR_BASE_HISTORICA_PERIODO_FIVI } from '../../global';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResCargueExcelFivi } from 'src/app/modelos/ResCargueExcelFivi';

@Injectable({
  providedIn: 'root'
})
export class AdmininformacionService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

  TodosEstadosPeriodoActivoAdminInfoChv():Observable<VistaAdminInfoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + ESTADO_INFORMACION_PERIODO_ACTIVO_CHV;
    return this.http.get<VistaAdminInfoI[]>(direccion, {'headers': header});
  }

  consultarBaseHistoricaCHV(consulta:ConsultaFuenteI):Observable<ResCargueExcel[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + CONSULTAR_BASE_HISTORICA_PERIODO_CHV;
    const body = consulta;
    return this.http.post<ResCargueExcel[]>(direccion,body, {'headers': header});
  }

  consultarBaseHistoricaFivi(consulta:ConsultaFuenteI):Observable<any[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + CONSULTAR_BASE_HISTORICA_PERIODO_FIVI;
    const body = consulta;
    return this.http.post<any[]>(direccion,body, {'headers': header});
  }

}
